import { createFileRoute } from "@tanstack/react-router";

import { WebsiteTrafficDashboard } from "../tools/dashboards/WebsiteTrafficDashboard";

function WebsiteTrafficRoute() {
  return <WebsiteTrafficDashboard />;
}

export const Route = createFileRoute("/_app/dashboards/website-traffic")({
  component: WebsiteTrafficRoute,
});
